import { render, staticRenderFns } from "./importTerminal.vue?vue&type=template&id=5fab6209&scoped=true"
import script from "./importTerminal.vue?vue&type=script&lang=js"
export * from "./importTerminal.vue?vue&type=script&lang=js"
import style0 from "./importTerminal.vue?vue&type=style&index=0&id=5fab6209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fab6209",
  null
  
)

export default component.exports